// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__RYp8X","perdeu":"LoginForm_perdeu__g8VH1","cadastro":"LoginForm_cadastro__YbL41","subtitle":"LoginForm_subtitle__3xTb1"};